<template>

  <div class="page">

      <div class="main-content">
        
        <div class="banner">
        <img class="logo" src="../../assets/img/2235.svg" alt/>
        </div>

        <!-- <div v-if="listMenu && listMenu.length > 0"> -->

          <div v-if="isShowMenu" class="sidebar">
              <div class="menu-btn" @click.stop="doShowMenu">
                <img class="icon" src="../../assets/img/clear-popup-w.svg" alt/>
              </div>
              <div
                v-for="(item, index) in listMenu"
                :key="index"
                @click.stop="doSelectItem(item.id)">
                <div class="menuItem" :class="item.id == id ? 'menuItem-sel' : ''">{{ item.title }}</div>
              </div>
          </div>

        <!-- </div> -->
        
        <div class="content2"> 

          <div class="title">
            <img v-if="!isShowMenu" @click="doShowMenu" class="icon2" style="margin-right: 20px;" src="../../assets/img/more.svg" alt/>
            <div v-html="title"></div>
          </div>

          <scroll-view>
            <div @click="handleClick" class="web-view link-box" v-html="formattedRichContent"></div>
          </scroll-view>

        </div>

      </div>

      <div v-show="is_showQrcode" class="qrcode-bg" alt @click="closeQrcode">
      
        <div v-show="is_showQrcode"  class="qrcode-v">
        
          <img class="qrcode-img" :src="info.xacode"/>
          <div class="qrcode-memo">微信扫码查看</div>
        </div>

      </div>

    <!-- tip -->
    <transition name="el-zoom-in-top">
      <div class="generalTip1">
        <div class="generalTip"
            :class="tipType?'generalTip_b':'generalTip_r'" v-show="tipShow">
          <p>{{ tipMessage }}</p>
        </div>
      </div>
    </transition>

  </div>
</template>
  
<script>

import { obtain } from "@/request/api";
import { Message } from "element-ui";
import { getHelpNoteDetail,getHelpNotes } from "@/request/api";
import { checkIsMiniApp,checkIsMobile,checkIsIOS } from "@/utils/common";
import Axios from "axios";

export default {
  name: "userHelpDetail",
  data() {
    return {
      id: 0,
      // richContent: '',
      rawContent: '', 
      title: '',
      info:null,

      listMenu: null,
      tipShow: false,
      tipType: false,
      tipMessage: "",

      isiOS:false,
      isMobile:false,
      isShowMenu:true,

      is_showQrcode:0,
    };
  },
  computed: {
    formattedRichContent() {
      let formattedText = this.rawContent;

      formattedText = formattedText.replace(
        /<p>(.*?)<\/p>/g,
        '<p class="p">$1</p>'
      );

      formattedText = formattedText.replace(
        /<strong>(.*?)<\/strong>/g,
        '<strong class="strong">$1</strong>'
      );

      formattedText = formattedText.replace(
        /<a>(.*?)<\/a>/g,
        '<a class="a">$1</a>'
      );

      formattedText = formattedText.replace(
        /<ul>(.*?)<\/ul>/g,
        '<ul class="ul">$1</ul>'
      );

      formattedText = formattedText.replace(
        /<li>(.*?)<\/li>/g,
        '<li class="li">$1</li>'
      );

      /*
      //替换发送邮箱
      formattedText = formattedText.replace(
        /email:/g,
        'mailto:'
      );

      //帮助文档调整替换 subPage/userHelp/userHelpDetail?navLeft=true&scene=id
      formattedText = formattedText.replace(
        /subPage\/userHelp\/userHelpDetail/g,
        'home/userHelpDetail'
      );

      formattedText = formattedText.replace(
        /navLeft=true&scene/g,
        'id'
      );*/
      
      return formattedText;
    },
  },
  mounted() {
    let that = this

    that.isiOS = checkIsIOS();
    that.isMobile = checkIsMobile();

    if( that.isMobile)
    {
      that.isShowMenu = false;
    }

    console.log('route', this.$route);
    this.id = this.$route.query.id;

    if(!that.id)
    {
      // Message.error("没有相关内容!");
      that.tipShow = true;
      that.tipType = false;
      that.tipMessage = "没有相关内容";
      setTimeout(() => {
        that.tipShow = false;
      }, 1000);
      return
    }

    that.getNotes()
    that.getData()
  },
  methods: {
    getData()
    {
      let that = this

      let param = {
        id:that.id
      };

      console.log('param',param)
      getHelpNoteDetail(param).then((res) => {
      
        //console.log(res)
        if (res.data && res.data.data) 
        { 
          console.log(res.data.data)
          // that.richContent = res.data.data.content
          that.rawContent = res.data.data.content;
          that.title = res.data.data.title
          that.info = res.data.data
        }
        else
        {
          // Message.error("没有相关内容!");
          that.tipShow = true;
          that.tipType = false;
          that.tipMessage = "网络异常，请稍后重试";
          setTimeout(() => {
            that.tipShow = false;
          }, 1000);
        }
      })
    },
    getNotes()
    {
      let that = this
      let param = {
        limit: 1000,
        keywords:  '',
        category_id: 0,
        page: 1,
        isiOS:  that.isiOS? 1: 0,
      };

      //console.log('param',param)
      getHelpNotes(param).then((res) => {
        console.log('getHelpNotes', res)
        if (res.data && res.data.data) 
        { 
            that.listMenu = res.data.data
        }
        else
        {
          // Message.error("没有相关内容!");
          // that.tipShow = true;
          // that.tipType = false;
          // that.tipMessage = "没有相关内容";
          // setTimeout(() => {
          //   that.tipShow = false;
          // }, 1000);
        }
      })
    },
    doSelectItem(id)
    {
      let that = this
      that.id = id 
      that.getData()
      if(that.isMobile)
      {
        that.isShowMenu = false
      }
    },
    doShowMenu(){
      let that = this
      that.isShowMenu = !that.isShowMenu
    },
    closeQrcode()
    {
      let that = this
      that.is_showQrcode = 0
    },
    handleClick(event) {

      let that = this

      // 检查点击事件的target是否为a标签
      const aTag = event.target.closest('a');
      if (aTag) {

        // 阻止默认行为，防止跳转
        event.preventDefault();
        
        var href = aTag.href;
        //帮助
        if(href.indexOf('subPage/userHelp/userHelpDetail') >= 0)
        {
          href = href.replace(
          /subPage\/userHelp\/userHelpDetail/g,
          'home/userHelpDetail');

          href = href.replace(
            /navLeft=true&scene/g,
            'id');
          window.location.href = href;
          return;
        }

        //显示二维码
        console.log('xacode',that.info.xacode)
        that.is_showQrcode = 1;
        return;

        // // 处理a标签点击事件
        console.log('Rich text link clicked:', aTag.href);
        // // 可以在这里执行更多操作，例如打开新窗口或发送到服务器
        var href = aTag.href;
        if(href.indexOf('email:') == 0)
        {
          href = href.replace(/email:/g,'mailto:'); 
          window.location.href = href;
          return;
        }

        //电话
        if(href.indexOf('tel:') == 0)
        {
          window.location.href = href;
          return;
        }

         //帮助
        if(href.indexOf('subPage/userHelp/userHelpDetail') >= 0)
        {
          href = href.replace(
          /subPage\/userHelp\/userHelpDetail/g,
          'home/userHelpDetail');

          href = href.replace(
            /navLeft=true&scene/g,
            'id');
          window.location.href = href;
          return;
        }
      }
    }
  }
  
};
</script>

<style lang="less" scoped>
html,
body {
  height: 100%;
}

.page{
  height: 100vh;
  width: 100vh;
  position: fixed;
  background: rgba(30,30,30,1);
  overflow: hidden;
}
.banner{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 68px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;  
  align-items: center;
  background: rgba(25,25,25,1);
  z-index: 1000;
  border-bottom: 1px solid rgba(255,255,255,0.02);
}
.logo{
  height: 28px;
  margin-left: 20px;
}  
.icon{
  height: 20px;
}  
.icon2{
  height: 20px;
  margin-right: 20px;
  opacity: 0.4;
  cursor: pointer;
}  
.icon2:hover{
  height: 20px;
  opacity: 1;
  cursor: pointer;
}  

.text{
  // color: rgba(255,255,255,0.2);
  color: #fff;
  font-size: 22px;
  font-weight: 800;
  margin-left: 10px;
}
.text-sel{
 
}
.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.main-content {
  position: relative;
  top:68px;
  display: flex;
  overflow: hidden; 
  height: calc(100vh - 68px);
}

@media screen and (min-width: 1024px) {
  .sidebar{
  height: calc(100vh - 88px);
  width: 300px;
  background: rgba(25,25,25,1);
  overflow-y: auto; 
  padding: 0px 20px 20px 20px;
  position: fixed;
  top: 68px;
  left: 0;
  z-index: 1000;
  
  .menu-btn{
    position: fixed;
    height: 70px;
    width: 290px;
    display: flex;
    flex-direction: row;
    justify-content: right;
    align-items: center;
    cursor: pointer;
    opacity: 0.4;
  }

  .menu-btn:hover{
    opacity: 1;
    cursor: pointer;
  }

  .menuItem{
      color: rgba(255,255,255,.4);
      font-size: 16px;
      height: 20px;
      margin: 20px 0;
      font-weight: 400;
      cursor: pointer;
    }

    .menuItem:hover{
      color: rgba(255,255,255,.6);
      font-weight: 800;
      cursor: pointer;
    }

    .menuItem-sel{
      color: rgba(255,255,255,1);
      font-weight: 800;
      cursor: pointer;
    }

    .menuItem-sel:hover{
      color: rgba(255,255,255,1);
      font-weight: 800;
      cursor: pointer;
    }

  }
  .title {
  padding: 0 30px;
  width: 700px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  }

  .web-view {
  padding: 60px 30px 100px 30px;
  width: 700px;
  }

}
@media screen and (max-width: 1024px) {
  
  .sidebar-bg{
    width: 100%;
    height: calc(100vh - 68px - constant(safe-area-inset-bottom));
    height: calc(100vh - 68px - env(safe-area-inset-bottom));
    position: fixed;
    left: 0;
    top: 68px;
    z-index: 200;
    background: rgba(255,255,255,0.8);
  }

  .sidebar{
  width: 300px;
  height: calc(100% - 88px);
  background: rgba(25,25,25,1);
  overflow-y: auto; 
  padding: 0px 20px 20px 20px;
  position: fixed;
  top: 68px;
  left: 0;
  z-index: 1000;

  .menu-btn{
    position: fixed;
    height: 70px;
    width: 290px;
    display: flex;
    flex-direction: row;
    justify-content: right;
    align-items: center;
    cursor: pointer;
    opacity: 0.4;
  }

  .menu-btn:hover{
    opacity: 1;
    cursor: pointer;
  }

  .menuItem{
      color: rgba(255,255,255,.4);
      font-size: 16px;
      height: 20px;
      margin: 20px 0;
      font-weight: 400;
    }

    .menuItem-sel{
      color: rgba(255,255,255,1);
      font-weight: 800;
    }
  }

  .title {
  width: calc(100vw - 60px); 
  padding: 0 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  }

  .web-view {
  padding: 60px 30px 100px 30px;
  width: calc(100vw - 60px);
  }

}

.content {
  height: calc(100vh - 68px);
  width: calc(100vw - 340px);
  background: rgba(30,30,30,1);
  overflow-y: auto;
  padding: 0px;
  position: fixed;
  top: 68px;
  left: 340px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  }

  .content2 {
  height: calc(100vh - 68px);
  width: 100vw;
  background: rgba(30,30,30,1);
  overflow-y: auto;
  padding: 0px;
  position: fixed;
  top: 68px;
  left: 0px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  }

.title {
  position: relative;
  height: 168px;
  background: rgba(30,30,30,1);
  color: rgba(255,255,255,1);
  z-index: 10; 
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  font-size: 20px;
  font-weight: 800;
  border-bottom: 1px solid rgba(255,255,255,0.02);
}
.web-view{
  position: relative;
  // height: calc(100vh - 128px);
  overflow-y: auto; 
  font-size: 15px;
  background: rgba(30,30,30,1);
  color: rgba(255,255,255,0.8);
  line-height: 30px;
}  
::-webkit-scrollbar {
  width: 8px; 
}
::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.05); 
  border-radius: 4px;
  cursor: pointer;
}
::-webkit-scrollbar-thumb:hover {
  background: rgba(255,255,255,0.1);
}

.qrcode-bg{
      position:absolute;
      z-index: 9000;
      left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0,0,0,0.8);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    
    .qrcode-v{
      position:absolute;
      z-index: 9100;
      width:300px;
      height: 380px;
      background: rgba(255,255,255,1);
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
    }

    .qrcode-img{
      // position:absolute;
      width: 240px;
      margin: 40px 0 0 0px;
      display: flex;
      justify-content: center;
    }

    .qrcode-memo{
      // position:absolute;
      margin-bottom: 40px;
      font-size:18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color:rgba(0,0,0,1);
      text-align: center;
    }

    .qrcode-ref{
      position: absolute;
      bottom: 40px;
      font-size: 14px;
      font-weight: bold;
      color: #0072FF;
      cursor: pointer;
    }

.generalTip1 {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      display: flex;
      flex-direction:column;
      justify-content: center;
      align-items: center;
      z-index: 1009;

      .generalTip {
      position: fixed;
      padding: 0 60px;
      height: 60px;
      line-height: 60px;
      border-radius: 60px;
      top: 20px;
      color: #ffffff;
      font-size: 24px;
      text-align: center;
      }

      .generalTip_r {
      background: #ec4d3d;
      }

      .generalTip_b {
      background: #000;
    }
}

// .link-box {
//   :deep(a) {
//     color: #1E90FF !important;
//     &:hover {
//       color: #1E90FF !important;
//     }
//     &:link {
//       color: #1E90FF !important;
//     }
//     &:visited {
//       color: #1E90FF !important;
//     }
//     &:active {
//       color: #1E90FF !important;
//     }
//   }

  .link-box {
  :deep(a) {
    color: #1E90FF !important;
    -webkit-text-fill-color: #1E90FF !important;
    &:hover,
    &:visited,
    &:active {
      color: #1E90FF !important;
      -webkit-text-fill-color: #1E90FF !important;
    }
  }
}


</style>